import { render, staticRenderFns } from "./cascader-column.vue?vue&type=template&id=8157cde2&"
import script from "./cascader-column.vue?vue&type=script&lang=js&"
export * from "./cascader-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports